export default __webpack_public_path__ + "img/7d0161c7db02bf1d1dab57e0429c8776.svg";